import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorNetflix = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="#B1060F"
      d="M13.849 1.017 13.84 5.88l-.009 4.862-.399-1.129v-.003l-.518 10.823c.51 1.435.781 2.202.784 2.205.003.003.293.02.643.038 1.059.052 2.373.165 3.371.289.232.029.428.043.443.032.014-.012.017-4.96.014-11L18.16 1.018H13.85ZM6.05 1.003v10.99c0 6.046.007 10.997.015 11.006.009.008.382-.03.834-.078.451-.05 1.073-.113 1.383-.14.474-.04 1.898-.13 2.06-.132.05 0 .052-.246.058-4.657l.009-4.656.344.973c.052.15.07.196.122.344l.518-10.82-.177-.5c-.422-1.196-.781-2.206-.796-2.252L10.392 1H6.05v.003Z"
    />
    <path
      fill="#B1060F"
      d="M13.849 1.017 13.84 5.88l-.009 4.862-.399-1.129v-.003l-.518 10.823c.51 1.435.781 2.202.784 2.205.003.003.293.02.643.038 1.059.052 2.373.165 3.371.289.232.029.428.043.443.032.014-.012.017-4.96.014-11L18.16 1.018H13.85ZM6.05 1.003v10.99c0 6.046.007 10.997.015 11.006.009.008.382-.03.834-.078.451-.05 1.073-.113 1.383-.14.474-.04 1.898-.13 2.06-.132.05 0 .052-.246.058-4.657l.009-4.656.344.973c.052.15.07.196.122.344l.518-10.82-.177-.5c-.422-1.196-.781-2.206-.796-2.252L10.392 1H6.05v.003Z"
    />
    <path
      fill="url(#ColorNetflix_svg__a)"
      d="M6.05 1.003v6.17L10.398 18.7c0-.263 0-.408.003-.709l.009-4.656.344.973c1.91 5.417 2.937 8.322 2.943 8.328.003.003.293.02.643.038 1.059.052 2.373.165 3.37.289.233.029.43.043.444.032.008-.009.014-2.434.014-5.857L13.844 4.7 13.84 5.88l-.009 4.862-.4-1.129-2.222-6.28c-.422-1.195-.78-2.205-.795-2.251L10.385 1H6.052v.003Z"
    />
    <path
      fill="#E50914"
      d="m6.05 1.003 4.356 12.342v-.006l.344.973c1.913 5.414 2.94 8.32 2.946 8.325.003.003.293.02.643.038 1.059.052 2.373.165 3.37.289.23.029.43.043.44.032l-4.317-12.258v.003l-.4-1.129-2.222-6.28c-.422-1.195-.78-2.205-.795-2.251L10.385 1H8.219l-2.167.003Z"
    />
    <defs>
      <radialGradient
        id="ColorNetflix_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(.75458 -.2613 9.57202 27.64125 11.906 11.872)"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColorNetflix)
export default ForwardRef
